import axios from 'axios';

let retryTaskToken;
export const retryTask = async (connectionId, taskId) => {
  try {
    if (typeof retryTaskToken !== typeof undefined) {
      retryTaskToken.cancel('Operation canceled due to new request.');
    }

    retryTaskToken = axios.CancelToken.source();

    return axios.put(`connections/${connectionId}/tasks/${taskId}/retry`, {
      cancelToken: retryTaskToken.token,
    });
  } catch (err) {
    if (axios.isCancel(err)) {
      return {cancelPrevQuery: true};
    }

    throw err;
  }
};
